import Verified from './VerifiedContainer';

export default Verified

